import './Center.scss';

import { Board } from '../board/Board';
import { BettingPart } from '../betting-part/BettingPart';
import { TopPart } from '../top-part/TopPart';
import { MobileCenter } from '../mobile-center/MobileCenter';
import { observer } from 'mobx-react';
import { roundStore } from '../../platform/stores';
import { RoundStatus } from '../../platform/enums/round-status';

export const Center = observer(() => {
  const { roundStatus } = roundStore;

  return (
    <div className="center-component">
      <div className="top-part">
        <TopPart/>
        <div className={`${roundStatus !== RoundStatus.Started ? 'mobile-hidden' : ''}`}>
          <Board/>
        </div>
      </div>
      <div className={`bottom-part ${roundStatus !== RoundStatus.Started ? 'mobile-hidden' : ''}`}>
        <BettingPart/>
      </div>
      <MobileCenter/>
    </div>
  )
});
